export var FormFieldType;
(function (FormFieldType) {
    FormFieldType["INPUT"] = "Input";
    FormFieldType["DATEPICKER"] = "Datepicker";
    FormFieldType["DROPDOWN"] = "Dropdown";
    FormFieldType["BUTTON_RADIO"] = "ButtonRadio";
    FormFieldType["TEXTAREA"] = "Textarea";
    FormFieldType["BUTTON_SQUARE"] = "ButtonSquare";
})(FormFieldType || (FormFieldType = {}));
